import * as types from './mutation-types.js'
import categories from '@/services/api/categories'

const state = {
  categories: []
}

const actions = {
  async getCategories ({state, commit}) {
    let keys = await categories.getCategories()

    commit(types.SET_CATEGORIES, keys)
  }
}

const mutations = {
  [types.SET_CATEGORIES] (state, categories) {
    state.categories = categories
  }
}

const getters = {
  categories: state => state.categories
}

export default {
  state,
  actions,
  mutations,
  getters
}
